export const comments = [
  {
    id: 'comment-1',
    articleId: 'article-1',
    username: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20netizen%20avatar%20portrait%2C%20fun%20expression%2C%20colorful%20background%2C%20anime%20style&width=80&height=80&seq=avatar-c1&orientation=squarish',
    content: '我就说这个人设迟早要崩，果然不出所料！去年看他采访就觉得不对劲，说话支支吾吾的。',
    likes: 3256,
    date: '2026-07-06',
  },
  {
    id: 'comment-2',
    articleId: 'article-1',
    username: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Thoughtful%20person%20avatar%20portrait%2C%20calm%20expression%2C%20minimal%20style%2C%20simple%20background&width=80&height=80&seq=avatar-c2&orientation=squarish',
    content: '还是等官方回应吧，现在只有一方说辞。不过如果是真的，确实让人失望。',
    likes: 1823,
    date: '2026-07-06',
  },
  {
    id: 'comment-3',
    articleId: 'article-1',
    username: '内娱爆料君',
    avatar: 'https://readdy.ai/api/search-image?query=Mysterious%20insider%20avatar%20portrait%2C%20hidden%20face%2C%20dark%20background%2C%20dramatic%20lighting&width=80&height=80&seq=avatar-c3&orientation=squarish',
    content: '其实圈内早就传开了，只是之前没有实锤。这次被拍到照片，估计公关也压不住了。',
    likes: 4521,
    date: '2026-07-06',
  },
  {
    id: 'comment-4',
    articleId: 'article-2',
    username: '购物达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Shopping%20enthusiast%20avatar%20portrait%2C%20excited%20expression%2C%20bright%20background&width=80&height=80&seq=avatar-c4&orientation=squarish',
    content: '我是受害者之一！在她直播间买的面膜用了一次就过敏，找客服根本不认账。现在终于有人站出来揭露了！',
    likes: 2890,
    date: '2026-07-05',
  },
  {
    id: 'comment-5',
    articleId: 'article-2',
    username: '打假先行者',
    avatar: 'https://readdy.ai/api/search-image?query=Truth%20seeker%20avatar%20portrait%2C%20determined%20look%2C%20simple%20background&width=80&height=80&seq=avatar-c5&orientation=squarish',
    content: '直播带货行业早就该整顿了。一些主播为了赚钱毫无底线，假货利润高就铤而走险。',
    likes: 2156,
    date: '2026-07-05',
  },
  {
    id: 'comment-6',
    articleId: 'article-3',
    username: '互联网老兵',
    avatar: 'https://readdy.ai/api/search-image?query=Experienced%20professional%20avatar%20portrait%2C%20wise%20look%2C%20simple%20background&width=80&height=80&seq=avatar-c6&orientation=squarish',
    content: '我在互联网行业干了15年，这种套路见多了。高管拿奖金、底层被裁，这是标准操作。关键是看有没有法律途径维权。',
    likes: 1678,
    date: '2026-07-04',
  },
  {
    id: 'comment-7',
    articleId: 'article-9',
    username: '追星十年不改初心',
    avatar: 'https://readdy.ai/api/search-image?query=Fan%20girl%20avatar%20portrait%2C%20emotional%20expression%2C%20pink%20background%2C%20kpop%20style&width=80&height=80&seq=avatar-c7&orientation=squarish',
    content: '我不信！！！他们在一起那么多年了，怎么可能说分就分。等官方声明，现在都是营销号在造谣！',
    likes: 5678,
    date: '2026-06-28',
  },
  {
    id: 'comment-8',
    articleId: 'article-9',
    username: '情感分析师李姐',
    avatar: 'https://readdy.ai/api/search-image?query=Relationship%20expert%20avatar%20portrait%2C%20understanding%20smile%2C%20warm%20background&width=80&height=80&seq=avatar-c8&orientation=squarish',
    content: '从心理学角度分析，网红情侣能走到最后的概率本来就很低。聚光灯下的感情太脆弱了。',
    likes: 2134,
    date: '2026-06-28',
  },
  {
    id: 'comment-9',
    articleId: 'article-6',
    username: '法律人张三',
    avatar: 'https://readdy.ai/api/search-image?query=Lawyer%20avatar%20portrait%2C%20professional%20look%2C%20serious%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-c9&orientation=squarish',
    content: '伤情鉴定报告+聊天记录+录音录像，这证据链太完整了。建议受害者走刑事自诉程序，家暴属于故意伤害。',
    likes: 3890,
    date: '2026-07-01',
  },
  {
    id: 'comment-10',
    articleId: 'article-6',
    username: '正义不会迟到',
    avatar: 'https://readdy.ai/api/search-image?query=Justice%20advocate%20avatar%20portrait%2C%20strong%20expression%2C%20simple%20background&width=80&height=80&seq=avatar-c10&orientation=squarish',
    content: '三年了才敢站出来，可见受害者经历了多大的心理压力。希望大家多给受害者一些支持，少一些冷嘲热讽。',
    likes: 5621,
    date: '2026-07-02',
  },
];

export type Comment = typeof comments[0];